import {AgentNs} from '@shared/types';

/** LLM Audit (debug) ekranı route'ları. <p> Yetki. */
export const llmAuditRoutes = [
  {
    path: '/llm-audit/:workspaceKey/:projectKey',
    name: AgentNs.AgentRouteEnums.LLM_AUDIT,
    component: () => import('@domains/llm-audit/views/llm-audit.view.vue'),
    props: true
  }
];
